export const chartColors = [
    'var(--data-vis-chart-color-1-standard)',
    'var(--data-vis-chart-color-2-standard)',
    'var(--data-vis-chart-color-3-standard)',
    'var(--data-vis-chart-color-4-standard)',
    'var(--data-vis-chart-color-5-standard)',
    'var(--data-vis-chart-color-6-standard)',
    'var(--data-vis-chart-color-7-standard)',
    'var(--data-vis-chart-color-8-standard)',
    'var(--data-vis-chart-color-9-standard)',
    'var(--data-vis-chart-color-10-standard)',
];

export const lightChartColors = [
    'var(--data-vis-chart-color-1-subdued)',
    'var(--data-vis-chart-color-2-subdued)',
    'var(--data-vis-chart-color-3-subdued)',
    'var(--data-vis-chart-color-4-subdued)',
    'var(--data-vis-chart-color-5-subdued)',
    'var(--data-vis-chart-color-6-subdued)',
    'var(--data-vis-chart-color-7-subdued)',
    'var(--data-vis-chart-color-8-subdued)',
    'var(--data-vis-chart-color-9-subdued)',
    'var(--data-vis-chart-color-10-subdued)',
];

export const chartColorSets = chartColors.map((color, index) => ({
    primary: color,
    light: lightChartColors[index],
}));

export const RETENTION_VIS_BLUE_100 = 'var(--data-vis-blue-vis-blue-120)';

export const RETENTION_BENCHMARK_CONSTANTS = {
    best: {
        border: 'var(--data-vis-green-vis-green-120)',
        hover: 'var(--data-vis-green-vis-green-30)',
        percentile: '90th',
    },
    good: {
        border: 'var(--data-vis-green-vis-green-100)',
        hover: 'var(--data-vis-green-vis-green-30)',
        percentile: '75th',
    },
    median: {
        border: 'var(--data-vis-neutrals-vis-neutral-120)',
        hover: 'var(--data-vis-neutrals-vis-neutral-30)',
        percentile: '50th',
    },
    low: {
        border: 'var(--palette-yellow-70)',
        hover: 'var(--palette-yellow-20)',
        percentile: '25th',
    },
};

const FUNNEL_CHART_HOVER_COLORS = [
    'var(--data-vis-chart-color-1-hover)',
    'var(--data-vis-chart-color-2-hover)',
    'var(--data-vis-chart-color-3-hover)',
    'var(--data-vis-chart-color-4-hover)',
    'var(--data-vis-chart-color-5-hover)',
    'var(--data-vis-chart-color-6-hover)',
    'var(--data-vis-chart-color-7-hover)',
    'var(--data-vis-chart-color-8-hover)',
    'var(--data-vis-chart-color-9-hover)',
    'var(--data-vis-chart-color-10-hover)',
];

const FUNNEL_CHART_DROPPED_HOVER_COLORS = [
    'var(--data-vis-chart-color-1-subdued-hover)',
    'var(--data-vis-chart-color-2-subdued-hover)',
    'var(--data-vis-chart-color-3-subdued-hover)',
    'var(--data-vis-chart-color-4-subdued-hover)',
    'var(--data-vis-chart-color-5-subdued-hover)',
    'var(--data-vis-chart-color-6-subdued-hover)',
    'var(--data-vis-chart-color-7-subdued-hover)',
    'var(--data-vis-chart-color-8-subdued-hover)',
    'var(--data-vis-chart-color-9-subdued-hover)',
    'var(--data-vis-chart-color-10-subdued-hover)',
];

export const FUNNEL_CHART_COLORS = {
    continued: chartColors,
    dropped: lightChartColors,
    hover: FUNNEL_CHART_HOVER_COLORS,
    droppedHover: FUNNEL_CHART_DROPPED_HOVER_COLORS,
    selected: FUNNEL_CHART_HOVER_COLORS,
    droppedSelected: FUNNEL_CHART_DROPPED_HOVER_COLORS,
};

export const GOAL_CHART_COLORS = {
    data: 'var(--data-vis-magenta-vis-magenta-120)',
    baseline: 'var(--data-vis-blue-vis-blue-130)',
    target: 'var(--data-vis-purple-vis-purple-120)',
};

export const LISTEN_CHART_COLORS = [
    'var(--data-vis-blue-vis-blue-100)',
    'var(--data-vis-magenta-vis-magenta-100)',
    'var(--data-vis-green-vis-green-100)',
    'var(--data-vis-orange-vis-orange-120)',
    'var(--data-vis-teal-vis-teal-100)',
];

export const USER_FREQUENCY_CHART_COLORS = [
    'var(--palette-teal-60)',
    'var(--palette-blue-30)',
    'var(--data-vis-teal-vis-teal-30)',
];

export const PEOPLE_DWM_CHART_COLORS = [
    'var(--data-vis-teal-vis-teal-130)',
    'var(--data-vis-purple-vis-purple-100)',
    'var(--data-vis-magenta-vis-magenta-120)',
];

export const WORKFLOW_TOTALS_CHART_COLORS = [
    'var(--static-palette-pink-110)',
    'var(--palette-blue-60)',
    'var(--palette-orange-70)',
];

export const NPS_COLOR_MAP = {
    detractors: 'var(--palette-red-60)',
    passive: 'var(--palette-yellow-60)',
    promoters: 'var(--palette-green-60)',
};

export default chartColors;
